import './App.scss';
import React, { useEffect, useRef } from 'react';
import 'aframe';
import {Scene} from 'aframe-react';

function App() {

  const videoRef = useRef();

  useEffect(() => {
    const videoElement = videoRef.current;

    navigator.mediaDevices.getUserMedia({ video: true })
    .then((stream) => {
      videoElement.srcObject = stream;
      videoElement.addEventListener('loadedmetadata', () => {
        videoElement.play();
      });
    })
    .catch((error) => {
      console.error('Error accessing camera:', error);
    });
  }, []);

  return (
    <div className="App">
      <div style={{ width: '100%', height: '100vh', position: 'relative' }}>
      <video
        id="cameraFeed"
        ref={videoRef}
        playsInline
        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
      />
      <a-scene
        embedded
        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
        arjs='sourceType: webcam;'>

        <a-assets>
          <video id="cameraFeed" ref={videoRef} playsInline style={{ display: 'block', width:360, height:240 }} />
        </a-assets>
        
        <a-marker preset='./berlintower.jpeg'>
          <a-box position="0 0.5 0" color="red" />
        </a-marker>

        <a-camera device="user" />
      </a-scene>

      
      </div>
    </div>
  );
}

export default App;
